<div class="paginator prevent-select">
  <div class="w-full flex place-content-center">
    
    <div [class]="'paginator-left mr-2 ' + arrowLeft" [ngClass]="{'opacity-0 pointer-events-none': current === 1}">
      <span (click)="prevPage()">
        <ng-content select="[arrowLeft]"></ng-content>
      </span>
    </div>
    <div class="col col-6">
      <div class="paginator-center">

        <span *ngIf="total > 0" (click)="changePage(1)" [class]="'paginator-box ' + customBox  + ' ' +(current === 1?customBoxSelected : '')" [ngClass]="{'selected': current === 1}">
          1
        </span>
        <span *ngIf="((total > 1 && current < 3) || (total > 1 && total < 6))" (click)="changePage(2)"
          [class]="'paginator-box ' + customBox + ' ' +(current === 2?customBoxSelected : '')" [ngClass]="{'selected': current === 2}">
          2
        </span>
        <span *ngIf="current > 2 && total > 5" [class]="'paginator-box ' + customBox">...</span>
        <span *ngIf="((total > 2 && current < 3) || (total > 2 && total < 6))" (click)="changePage(3)"
          [class]="'paginator-box ' + customBox + ' ' +(current === 3?customBoxSelected : '')" [ngClass]="{'selected': current === 3}">
          3
        </span>
        <span *ngIf="total > 5 && current > 2 && current < total - 1" [class]="'paginator-box ' + customBox + ' ' +(current < total - 1?customBoxSelected : '')"
          [ngClass]="{'selected': current < total - 1}">
          {{current}}
        </span>
        <span *ngIf="total > 3 && total < 6" (click)="changePage(4)" [class]="'paginator-box ' + customBox + ' ' +(current === 4?customBoxSelected : '')"
          [ngClass]="{'selected': current === 4}">
          4
        </span>
        <span *ngIf="total === 5" (click)="changePage(5)" [class]="'paginator-box ' + customBox + ' ' +(current === 5?customBoxSelected : '')" [ngClass]="{'selected': current === 5}">
          5
        </span>
        <span *ngIf="total > 5 && current < total - 1" [class]="'paginator-box ' + customBox">...</span>
        <span *ngIf="total > 5 && current >= total - 1" (click)="changePage(total - 2)" [class]="'paginator-box ' + customBox + ' ' +(current===total - 2?customBoxSelected : '')"
          [ngClass]="{'selected': current === total - 2}">
          {{total - 2}}
        </span>
        <span *ngIf="total > 5 && current >= total - 1" (click)="changePage(total - 1)" [class]="'paginator-box ' + customBox + ' ' +(current ===total - 1?customBoxSelected : '')"
          [ngClass]="{'selected': current === total - 1}">
          {{total - 1}}
        </span>
        <span *ngIf="total > 5" (click)="changePage(total)" [class]="'paginator-box ' + customBox + ' ' +(current === total?customBoxSelected : '')"
          [ngClass]="{'selected': current === total}">
          {{total}}
        </span>
      </div>
    </div>
    <div [class]="'ml-2 paginator-right ' + arrowRight"  [ngClass]="{'opacity-0 pointer-events-none': current === total}">
      <span (click)="nextPage()">
        <ng-content select="[arrowRight]"></ng-content>
      </span>
    </div>
    
  </div>
</div>